<div class="container">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h2>Quotations List</h2>
  </div>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div class="d-flex gap-2 mb-3">
      <div class="form-floating">
        <select id="financialYearSelect" class="form-select" [(ngModel)]="selectedFinancialYear"
          (change)="applyFilters()">
          <option value="" disabled selected hidden></option>
          <option value="all">ALL</option>
          <option *ngFor="let year of financialYears" [value]="year">{{ year }}</option>
        </select>
        <label for="financialYearSelect">Financial Year</label>
      </div>

      <div class="form-floating">
        <select id="stageSelect" class="form-select" [(ngModel)]="selectedStage" (change)="filterByStage()">
          <option value="" disabled selected hidden></option>
          <option *ngFor="let stage of stages" [value]="stage">{{ stage.toUpperCase() }}</option>
        </select>
        <label for="stageSelect">Stage</label>
      </div>
    </div>


    <button (click)="exportToExcel()" class="btn btn-success btn-sm">
      <i class="fa fa-file-excel"></i> Export to Excel
    </button>
  </div>

  <div class="custom-table-wrapper">
    <table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th>Quote #</th>
          <th>Assigned To</th>
          <th>Date</th>
          <th>Client</th>
          <th>Value</th>
          <th>Region</th>
          <th>Importance</th>
          <th>Actions</th>
        </tr>
        <!-- Filtering Row -->
        <tr>
          <th><input type="text" class="form-control" placeholder="Search Quote #" [(ngModel)]="filter.quoteId"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Assigned To" [(ngModel)]="filter.assignedTo"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Date" [(ngModel)]="filter.date"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Client" [(ngModel)]="filter.client"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Value" [(ngModel)]="filter.value"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search State" [(ngModel)]="filter.state"
              (input)="applyFilters()" /></th>
          <th><input type="text" class="form-control" placeholder="Search Importance" [(ngModel)]="filter.importance"
              (input)="applyFilters()" /></th>
          <th>
            <button (click)="resetFilters()" class="btn btn-primary btn-sm">
              <i class="fa fa-x" aria-hidden="true"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let quot of filteredQuotationData">
          <td>{{ (quot.quotationFields.quotationId) }}</td>
          <td>{{ quotationCommonServices?.getAssignedToName(quot.quotationFields.quotationAssignedToId)?.username || '-'
            }}</td>
          <td>{{ quot.quotationFields.quotationDate | date:'dd/MM/yyyy' }}</td>
          <td>{{ quotationCommonServices?.getClientName(quot.quotationFields.quotationCompanyId)?.companyName || '-' }}
          </td>
          <td>{{ quot.quotationFields.grandTotal }}</td>
          <td>{{ this.quotationCommonServices
            ?.getClientName(quot.quotationFields.quotationCompanyId)
            ?.region }}</td>
          <td>{{ quot.quotationFields.quotationImportance.toUpperCase() }}</td>
          <td>
            <button (click)="editQuotation(quot)" class="btn btn-primary btn-sm"
              [disabled]="!hasPermission('QuotationsAddNewPermission')">
              <i class="fa fa-edit" aria-hidden="true"></i>
            </button>
            <button (click)="viewQuotation(quot)" class="btn btn-primary btn-sm">
              <i class="fa fa-eye" aria-hidden="true"></i>
            </button>
            <button (click)="viewQuotationDetails(quot)" class="btn btn-primary btn-sm">
              <i class="fa fa-file-invoice" aria-hidden="true"></i>
            </button>
            <button (click)="deleteQuotation(quot)" class="btn btn-danger btn-sm">
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
            <button
              *ngIf="hasPermission('WorkOrdersAddNewPermission') && (quot.quotationFields.quotationStage.toLowerCase() === 'proforma' || quot.quotationFields.quotationStage.toLowerCase() === 'publish')"
              (click)="createWorkOrder(quot)" class="btn btn-success btn-sm" title="Create Work Order">
              <i class="fa fa-cogs" aria-hidden="true"></i>
            </button>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>